const Contact = () => {
  return (
    <footer className=" bg-primary py-6 text-center">
      <p className="md:text-lg text-sm">
        
        Crafted with <span className="text-red-500">💖</span> and{" "}
        <span className="font-bold">React</span> by Bharat
        <br />
        <span className="md:text-sm text-xs opacity-75">Empowered by Tailwind CSS</span>
      </p>
    </footer>
  );
};
export default Contact;
